import { p as proxyCustomElement, H, h } from './p-bfa0dc67.js';
import { c as classNames } from './p-df8c8ec2.js';

const biAccordionContentCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}.accordion_content{display:flex;font-weight:500;flex-direction:column;gap:8px;align-items:start;align-self:stretch;width:100%;min-width:inherit;flex-wrap:wrap;padding:unset;padding:10px 7px 16px;color:inherit}.accordion_content.hidden{display:none}.accordion_content.noPadding{padding:0}.accordion_content.small{font-size:0.75rem;line-height:1.5}.accordion_content.medium{font-size:1rem;line-height:1.5}.accordion_content.large{font-size:1.25rem;line-height:1.5}";
const BiAccordionContentStyle0 = biAccordionContentCss;

const BiAccordionContent$1 = /*@__PURE__*/ proxyCustomElement(class BiAccordionContent extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.accordionElement = null;
        this.noPadding = false;
        /**
         * Size of the accordion content.
         * @default 'medium'
         */
        this.size = 'medium';
    }
    async updateIsExpanded() {
        this.isExpanded = this.accordionElement?.isExpanded;
    }
    componentWillRender() {
        this.accordionElement = this.el.parentElement;
        this.updateIsExpanded();
    }
    render() {
        return (h("div", { key: '19ea884d1069731625e108062b038ff711c99c5b', class: classNames('accordion_content', this.size, !this.isExpanded && 'hidden', this.noPadding && 'noPadding') }, h("slot", { key: '27fb05175852d278dbedd136682c6ac52bcfff36' })));
    }
    get el() { return this; }
    static get style() { return BiAccordionContentStyle0; }
}, [1, "bi-accordion-content", {
        "noPadding": [4, "no-padding"],
        "size": [1],
        "isExpanded": [32],
        "updateIsExpanded": [64]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-accordion-content"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-accordion-content":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiAccordionContent$1);
            }
            break;
    } });
}

const BiAccordionContent = BiAccordionContent$1;
const defineCustomElement = defineCustomElement$1;

export { BiAccordionContent, defineCustomElement };
